'use client'

import { useMemo } from 'react'

import { getSelectedColorFromSelectedOptions } from '@src/quince-components/src/molecules/productCard/productCard.helpers'
import { withProductContextProvider } from '@src/quince-site-common/src/contexts/product-context'

import ProductPageContext from '../../domains/ProductPageContext'
import MiniPDPCollection from '../../organisms/productPageSections/miniPDPCollection'
import { MiniPDPProductImages } from '../../organisms/productPageSections/miniPDPProductImages/miniPDPProductImages'
import { MiniPDPProductPurchase } from '../../organisms/productPageSections/miniPDPProductPurchase/miniPDPProductPurchase'
import { getInitialSelectedOptionsForProduct } from '../../organisms/productPageSections/productPurchase/ProductPurchase'

import styles from './miniPDP.module.scss'

const MiniPDP = ({ pageData }: { pageData: ProductPageContext }) => {
  const initialSelectedOption = useMemo(
    () => getInitialSelectedOptionsForProduct(pageData.product, pageData.sectionData),
    [pageData.product, pageData.sectionData],
  )
  const color = getSelectedColorFromSelectedOptions(initialSelectedOption)

  return (
    <>
      <div className={styles.miniPDP__container}>
        <MiniPDPProductImages
          sectionData={pageData.sectionData}
          product={pageData.product}
          selectedOptions={initialSelectedOption}
        />
        <MiniPDPProductPurchase
          product={pageData.product}
          selectedOptions={initialSelectedOption}
          sectionData={pageData.sectionData}
        />
      </div>
      <div className={styles.border} />
      <MiniPDPCollection
        collectionId={pageData.product.productRecommendations.mpdp.data.id}
        color={color ?? ''}
        productId={pageData.product.id}
      />
    </>
  )
}

export default withProductContextProvider(MiniPDP)
